import { ProfileTabType } from './types';

// 페이지네이션 상수
export const PAGE_SIZE = 20;

// 프로필 탭 상수
export const PROFILE_TABS: Record<ProfileTabType, string> = {
  tweets: 'tweets',
  projects: 'projects', 
  learning: 'learning',
  teaching: 'teaching',
  roadmaps: 'roadmaps'
} as const;

// 화면 크기 브레이크포인트
export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1200
} as const;

// 기본 프로필 이미지
export const DEFAULT_PROFILE_IMAGE = 'https://via.placeholder.com/150';
export const DEFAULT_COVER_IMAGE = 'https://via.placeholder.com/1200x300';

// 애니메이션 지속시간
export const ANIMATION_DURATION = {
  fast: 150,
  normal: 300,
  slow: 500
} as const;